import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../branch';
import { Configuration } from '../../../app.constants';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Injectable()
export class BranchService {
  private branchApiUrl: string = this._configuration.apiUrl + '/v2/branch';
  private companyApiUrl: string = this._configuration.apiUrl + '/v2/company';

  constructor(
    private _http: Http,
    private _configuration: Configuration,
    private _authService: AuthenticationService
  ) { }

  getBranches(): Observable<Branch[]> {
    let h: Headers = this._authService.getHeaders();

    return this._http.get(this.branchApiUrl, { headers: h }).map((response: Response) => <Branch[]>response.json().branches);
  }

  getBranch(id: number): Observable<Branch> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id + '');

    return this._http.get(this.branchApiUrl, { headers: h, search: s }).map((response: Response) => <Branch>response.json().branches[0]);
  }

  saveBranch(branch: Branch): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (branch.id) {
      s.append('id', branch.id + '');

      return this._http.put(this.branchApiUrl, branch, { headers: h, search: s }).map((response: Response) => response.json());
    } else {
      return this._http.post(this.branchApiUrl, branch, { headers: h, search: s }).map((response: Response) => response.json());
    }
  }

  deleteBranch(id: number): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id + '');

    return this._http.delete(this.branchApiUrl, { headers: h, search: s }).map((response: Response) => response);
  }

  getBranchesBySupplier(supplierId: number): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('supplier_id', supplierId + '');

    return this._http.get(this.branchApiUrl, { headers: h, search: s }).map(
      (response: Response) => (
        {
          supplierId: supplierId, 
          branches: <Branch[]>response.json().branches
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/branches/branch.service.ts